import { staticFile } from '@common/utils'
import Tooltip from '@components/common/tooltip'
import { StudentProjectDataType } from '@lib/types/student-project'
import { MutableRefObject } from 'react'
import { FastlyImage } from '@components/common/image'
import { Info } from 'react-feather'

type Props = {
  project: StudentProjectDataType
  IMAGE_PATH: string
  projectVideoCardRef: MutableRefObject<HTMLVideoElement>
}

const StudentProjectCard = ({
  project,
  IMAGE_PATH,
  projectVideoCardRef,
}: Props) => (
  <div
    className="container relative flex flex-col w-full mx-auto overflow-hidden bg-white shadow h-ful hover:shadow-xl"
    style={{
      borderRadius: '14px',
    }}
    onMouseEnter={() => projectVideoCardRef.current.play()}
    onMouseLeave={() => projectVideoCardRef.current.pause()}
  >
    <div className="flex justify-center" style={{ background: '#EDEDED' }}>
      <video
        ref={projectVideoCardRef}
        loop
        style={{ height: '228px' }}
        className="object-fill"
      >
        <source src={staticFile(project.projectVideo)} type="video/webm" />
      </video>
    </div>
    {project.studentImage && (
      <div className="absolute w-20 mb-8 ml-6 bottom-10">
        <FastlyImage
          src={`${IMAGE_PATH}${project.studentImage}.webp`}
          alt="project preview"
          height={100}
          width={100}
        />
      </div>
    )}
    <div className="flex flex-col justify-between h-full mb-4 ml-4 mr-4">
      <div className="flex items-center justify-between pt-6 pb-2 mx-5">
        <p className="mt-2 text-grey-800 font-600">{project.projectCategory}</p>
        <p
          className="text-right font-400 text-orange"
          style={{
            flexBasis: '100px',
          }}
        >{`Grade ${project.grade}`}</p>
      </div>
      <div className="flex items-center justify-start mx-5">
        <p className="pr-3 text-xl text-grey-900 font-600">
          {project.projectName}
        </p>
        <span className="pr-2">
          <Tooltip
            content={
              <p className="p-2 text-grey-900 font-400">
                {project.projectDescription}
              </p>
            }
            showOnHover
            placement="bottom-center"
          >
            <Info className="w-5 cursor-pointer text-grey-700 hover:text-orange" />
          </Tooltip>
        </span>
      </div>
      <p className="mx-5 mt-3 font-600 text-orange">{project.studentName}</p>
      {!project.showPlayStoreBUtton && (
        <div>
          <a
            href={project.projectLink}
            rel="noopener noreferrer"
            target="_blank"
            className="px-4 m-5 btn btn-orange font-600"
          >
            View Project
          </a>
        </div>
      )}

      {project.showPlayStoreBUtton && (
        <div>
          <a
            href={project.projectLink}
            rel="noopener noreferrer"
            target="_blank"
            className="ml-5"
          >
            <FastlyImage
              src={`${IMAGE_PATH}play-store.webp`}
              alt="Play store button image"
              height={40}
              width={130}
            />
          </a>
        </div>
      )}
    </div>
  </div>
)

export default StudentProjectCard
